import {sample} from 'effector';

import {setMainRole, $mainRole, $profile, setProfile, $isNG, setIsNG} from './index';

$mainRole.on(setMainRole, (_, data) => {
    if (data) {
        return data;
    }
    return null;
});

$profile.on(setProfile, (_, data) => {
    if (data) {
        return data;
    }
    return null;
});

sample({
    clock: $profile,
    fn: (profile) => profile?.roles[0] ?? null,
    target: setMainRole,
});

$isNG.on(setIsNG, (_, data) => data);
